const uniqueNonEmpty = (values = []) => {
  const seen = new Set();
  const out = [];
  values.forEach((raw) => {
    const text = String(raw || '').trim();
    if (!text) return;
    const key = text.toLowerCase();
    if (seen.has(key)) return;
    seen.add(key);
    out.push(text);
  });
  return out;
};

export const getSaleDispatchGuides = (row = {}) => {
  const guides = [];
  if (Array.isArray(row.delivery_dispatch_guides)) {
    guides.push(...row.delivery_dispatch_guides);
  }
  if (row.dispatch_guide) guides.push(row.dispatch_guide);
  return uniqueNonEmpty(guides);
};

export const getSaleInvoiceFolios = (row = {}) => {
  const folios = [];
  if (Array.isArray(row.linked_invoice_numbers)) {
    folios.push(...row.linked_invoice_numbers);
  }
  const manual = String(row.invoice_number || '').trim();
  if (manual) folios.push(manual);
  return uniqueNonEmpty(folios);
};

export const getSaleCreditDebitFolios = (row = {}) =>
  uniqueNonEmpty(Array.isArray(row.linked_credit_debit_numbers) ? row.linked_credit_debit_numbers : []);

export const formatSlashList = (items = [], fallback = '—') => {
  const list = uniqueNonEmpty(items);
  return list.length ? list.join(' / ') : fallback;
};

export const formatSaleBillingCell = (row = {}) => {
  const invoices = getSaleInvoiceFolios(row);
  const guides = getSaleDispatchGuides(row);
  const creditDebit = getSaleCreditDebitFolios(row);
  return {
    invoicesLine: invoices.length ? `Facturas: ${invoices.join(' / ')}` : 'Facturas: —',
    guidesLine: guides.length ? `Guías: ${guides.join(' / ')}` : 'Guías: —',
    creditDebitLine: creditDebit.length ? `NC/ND: ${creditDebit.join(' / ')}` : 'NC/ND: —',
  };
};

export const formatSaleDispatchCell = (row = {}) => ({
  legsLine: `${Number(row.legs_count || 0)} tramo${Number(row.legs_count || 0) === 1 ? '' : 's'}`,
  deliveriesLine: `${Number(row.deliveries_count || 0)} entrega${Number(row.deliveries_count || 0) === 1 ? '' : 's'}`,
  costLine: Number(row.dispatch_cost_total || 0),
});
